import { cn } from '@/utils/classnames';
import * as React from 'react';

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          'flex border border-input bg-background px-3 py-[0.6rem] ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 w-full min-w-0 bg-[#ffffff] dark:bg-[#1C1C1E] h-[2.8rem] rounded-[1.4rem] placeholder:text-[#7E7E7E] placeholder:text-[1.4rem] text-[1.4rem] text-[#000] dark:text-white',
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = 'Input';

export { Input };
